import { fetchAPIBranding } from "@src/data-hooks/branding/branding.service";
import { Themes } from "./Themes";
import { IFile, IRawCompanyBranding } from "@propely/propely-typings";

export class CustomBranding {
  static DISABLE_BRANDING = false;

  static logo?: IFile;

  static darkTextColor: string = "#1a1a1a";
  static lightTextColor: string = "#fff";

  static primaryColor: string = "#4f167b";
  static primaryTextColor: string = "#fff";

  static secondaryColor: string = "#4f167b";
  static secondaryTextColor: string = "#fff";
  static secondaryInactiveTextColor: string = "#d8c9f1";

  static buttonColor: string = "#6f47f2";
  static buttonHoverColor: string = "#7c5aea";
  static buttonTextColor: string = "#fff";

  static chartColors: string[] = [];

  static changeCustomBranding(): Promise<Error | undefined> {
    return fetchAPIBranding()
      .then((response) => {
        if (response.data.length > 0) {
          this.activateBranding(response.data[0].branding);
        } else {
          this.activateBranding(undefined);
        }
        return undefined;
      })
      .catch(() => {
        this.activateBranding(undefined);
        return new Error("Failed to fetch branding data");
      });
  }

  static activateBranding(data: IRawCompanyBranding | undefined) {
    Themes.updateTheme();
    if (!this.DISABLE_BRANDING) {
      this.darkTextColor = data?.darkTextColor ? data.darkTextColor : "#1a1a1a";
      this.lightTextColor = data?.lightTextColor ? data.lightTextColor : "#fff";
      this.primaryColor = data?.primaryColor ? data.primaryColor : "#4f167b";
      this.primaryTextColor = data?.primaryTextColor ? data.primaryTextColor : "#fff";
      this.secondaryColor = data?.secondaryColor ? data.secondaryColor : "#4f167b";
      this.secondaryTextColor = data?.secondaryTextColor ? data.secondaryTextColor : "#fff";
      this.secondaryInactiveTextColor = data?.secondaryInactiveTextColor ? data.secondaryInactiveTextColor : "#d8c9f1";
      this.buttonColor = data?.buttonColor ? data.buttonColor : "#6f47f2";
      this.buttonHoverColor = data?.buttonHoverColor ? data.buttonHoverColor : "#7c5aea";
      this.buttonTextColor = data?.buttonTextColor ? data.buttonTextColor : "#fff";

      this.chartColors = data?.chartColors ?? [];
      this.logo = data?.logo;
      this.chartColors = data?.chartColors ?? [];
    }

    //document.documentElement.style.setProperty("--primary-text-color", this.darkTextColor);
    //document.documentElement.style.setProperty("--light-text-color", this.lightTextColor);

    document.documentElement.style.setProperty("--primary-color", this.primaryColor);
    //document.documentElement.style.setProperty("--primary-text-color", this.primaryTextColor);

    document.documentElement.style.setProperty("--secondary-color", this.secondaryColor);
    document.documentElement.style.setProperty("--secondary-text-color", this.secondaryTextColor);
    document.documentElement.style.setProperty("--secondary-inactive-text-color", this.secondaryInactiveTextColor);

    document.documentElement.style.setProperty("--button-color", this.buttonColor);
    document.documentElement.style.setProperty("--button-hover-color", this.buttonHoverColor);
    document.documentElement.style.setProperty("--button-text-color", this.buttonTextColor);
  }
}

